import React from 'react';

export default React.lazy(() =>
    // adblockers don't like "SocialIcons" so rot13 = FbpvnyVpbaf
    import(/* webpackChunkName: "FbpvnyVpbaf" */ './SocialLinkRowItem')
);
